import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const AppToolTip = ({
    content,
    icon
  }) => {

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {content}
        </Tooltip>
      );

    return(
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 250 }}
        overlay={renderTooltip}
      >
        {icon}
    </OverlayTrigger>
    )
  }